// we don't include jQuery since wordpress loves to include itself. In future?

// bootstrap 3 uses less lets use the dist instead
import "../node_modules/typeface-montserrat";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import "../node_modules/typeface-rochester";
import './scss/varables.scss';
import './scss/legacy.scss';
import './scss/main.scss';
import './scss/home-2025.scss';
import './scss/cover.scss';
import './scss/subnav-bootstrap-3-fixes.scss';
import '../node_modules/bootstrap/dist/js/bootstrap.min';
import './scss/dj-page.scss';

import {base_fm} from './js/base.js';
import {bootstrap3MenuFixes} from './js/bootstrap-3-menu-fixes.js';

jQuery(document).ready(function () {
    base_fm();
    bootstrap3MenuFixes();
});